import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ICreateUserResponse, ICreateUser } from "../../common/types/userTypes";
import { createUserUrl } from "../../config";
import { Status } from "../../common/constants";
import axios from 'axios';
import { RootState } from "../../store";

const CREATE_USER: string = "createUser";
interface IInitialState {
  status: string;
  error: string | null;
  msg: string | null;
  queryParam: string | null;
}

const initialState: IInitialState = {
  status: Status.IDLE,
  error: null,
  msg: null,
  queryParam: null,
};

export const createUser = createAsyncThunk(
  CREATE_USER,
  async (payload: ICreateUser,{ getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const authToken = state.createUser.queryParam;
      const headers = {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json',
      };
      const response = await axios.put<ICreateUserResponse>(createUserUrl, payload, {
        headers
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const createUserSlice = createSlice({
  name: CREATE_USER,
  initialState,
  reducers: {
    updateQueryParams(state, action) {
      state.queryParam = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createUser.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.msg = "User Register Successfully!";
      })
      .addCase(createUser.rejected, (state, action) => {
         const errorPayload = action.payload as { response?: { data?: { error?: { message?: string }, message?: string } } };
        state.status = Status.FAILED;
        state.error = action.error.message;
        state.msg = errorPayload.response?.data?.error?.message || errorPayload.response?.data?.message || 'Unknown error occurred';
      });
  },
});

export const selector = (state: RootState) => state.createUser;
export const { updateQueryParams } = createUserSlice.actions;
export default createUserSlice.reducer;